import type { paths } from "@/api-schema";

export const ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE =
  "electronic-signature-template-configuration" as const;
export const ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH =
  `/v1/${ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE}` as const;
export const ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_OPERATION = "search" as const;
export const ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH =
  `${ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH}/${ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_OPERATION}` as const;

export type ElectronicSignatureTemplateConfigurationUpsertBody =
  paths[typeof ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH]["put"]["requestBody"]["content"]["application/json"];

export type ElectronicSignatureTemplateConfigurationUpsertResponse =
  paths[typeof ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH]["put"]["responses"][200]["content"]["application/json"];

export type ElectronicSignatureTemplateConfigurationSearchBody =
  paths[typeof ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type ElectronicSignatureTemplateConfigurationSearchParameters =
  paths[typeof ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH]["post"]["parameters"]["query"];

export type ElectronicSignatureTemplateConfigurationSearchResponse =
  paths[typeof ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_SEARCH_API_PATH]["post"]["responses"][200]["content"]["application/json"];
